<template>
  <v-section>
    <v-toolbar :title="title">
      <!-- TODO: До лучших времен -->
<!--      <template #default>-->
<!--        <v-select-->
<!--          :value="dateRange"-->
<!--          :options="dateRangeOptions"-->
<!--          :label="'name'"-->
<!--          :placeholder="$t('c.select.placeholderSelectRange')"-->
<!--          :disabled="loading"-->
<!--          @input="changeDateRange($event)"-->
<!--        />-->
<!--        <el-date-picker-->
<!--          v-if="isOtherDateRange"-->
<!--          v-model="customRange"-->
<!--          type="daterange"-->
<!--          align="right"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          range-separator="-"-->
<!--          unlink-panels-->
<!--          :start-placeholder="$t('c.datePicker.placeholderStartDate')"-->
<!--          :end-placeholder="$t('c.datePicker.placeholderEndDate')"-->
<!--          :disabled="loading"-->
<!--          :picker-options="datePickerOptions"-->
<!--          @change="changeCustomRange($event)"-->
<!--        />-->
<!--      </template>-->

      <template v-if='$slots.secondRowToolsLeft' #secondRowToolsLeft>
        <slot  name="secondRowToolsLeft"></slot>
      </template>

      <template v-if='$slots.secondRowToolsRight' #secondRowToolsRight>
        <slot  name="secondRowToolsRight"></slot>
      </template>

    </v-toolbar>

    <hr />

    <div class="table-wrapper">
      <v-placements-table
        v-loading="loading"
        :data="list"
        :default-sort="sort"
        :selection-column="selectionColumn"
        :damage-column="damageColumn"
        :empty-text="emptyText"
        :table-type="tableType"
        :cpl="accountCPL"
        @sort-change="changeSort($event)"
        @selection-change="$emit('selection-change', $event)"
        :highlight-reason-property="highlightReasonProperty"
        :classification-column="classificationColumn"
      />

      <v-row justify="center" class="pagination-wrapper" v-if="totalPage">
        <v-pagination
          layout="prev, pager, next"
          :page-size="1"
          :current-page="currentPage"
          :total="totalPage"
          :disabled="loading"
          @current-change="changeCurrentPage($event)"
        />
      </v-row>
    </div>
  </v-section>
</template>

<script>
import VPlacementsTable from '@/components/Placements/VPlacementsTable.vue'
import VPagination from '@/components/common/VPagination.vue'
import VToolbar from '@/components/common/VToolbar.vue'
import VSection from '@/components/common/VSection.vue'
import VRow from '@/components/common/VRow.vue'
import storeUtils from '@/mixins/storeUtils'
import * as types from '@/store/types'

export default {
  name: 'VTypePlacementsTable',

  components: {
    VPlacementsTable,
    VPagination,
    VToolbar,
    VSection,
    VRow
  },

  mixins: [storeUtils],

  props: {
    tableType: {
      type: String,
      required: true,
      validator: value => [
        types.WORST_PLACEMENTS,
        types.DISPUTED_PLACEMENTS,
        types.BEST_PLACEMENTS
      ].includes(value)
    },

    damageColumn: {
      type: Boolean,
      default: false
    },

    selectionColumn: {
      type: Boolean,
      default: false
    },

    classificationColumn: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      datePickerOptions: {
        firstDayOfWeek: 1
      }
    }
  },


  computed: {
    title() {
      const titles = {
        [types.WORST_PLACEMENTS]: this.$t('v.placements.titleWorstPlacements'),
        [types.DISPUTED_PLACEMENTS]: this.$t('v.placements.titleDisputedPlacements'),
        [types.BEST_PLACEMENTS]: this.$t('v.placements.titleBestPlacements')
      }
      return titles[this.tableType]
    },

    highlightReasonProperty() {
      return [types.WORST_PLACEMENTS, types.DISPUTED_PLACEMENTS].includes(this.tableType)
    },
    dateRangeOptions() {
      return this.$store.getters.dateRangeArray(this.$i18n)
    },
    accountCPL() {
      return this.$store.getters.accountCPL
    },
    placements() {
      return this.$store.state[this.tableType]
    },
    list() {
      return this.placements.list
    },
    loading() {
      return this.placements.loading
    },
    params() {
      return this.placements.params
    },
    isValidConversions() {
      return this.params
        .isValidConversions
    },
    hasActiveCampaigns() {
      return this.params.hasActiveCampaigns
    },
    emptyText() {
      if (this.isValidConversions) return this.$t('c.table.textEmpty')
      if (!this.hasActiveCampaigns) return this.$t('c.table.textEmptyNotActiveCampaigns')
      return this.$t('c.table.textEmptyVeryLowConversions')
    },
    dateRange() {
      return this.params.dateRange
    },
    isOtherDateRange() {
      return (
        this.dateRange
        && this.dateRange.value === 'OTHER_RANGE'
      )
    },
    canFetchPlacements() {
      return (
        (this.dateRange
          && this.dateRange.value !== 'OTHER_RANGE')
        || this.dateRange.length
      )
    },
    customRange: {
      get() {
        return this.params
          .customDateRange
      },
      set(value) {
        this.updateValue({
          key: 'customDateRange',
          value: value || []
        })
      }
    },
    currentPage() {
      return this.params.currentPage
    },
    totalPage() {
      return this.params.totalPage
    },
    sort() {
      return this.params.sort
    }
  },

  created() {
    // Установление default значения диапазона выборки
    if (this.dateRangeOptions && this.dateRangeOptions.length) {
      if (!this.dateRange) {
        this.updateValue({
          key: 'dateRange',
          value: this.dateRangeOptions[0]
        })
      }
    }
    // Получение площадок
    if (this.canFetchPlacements) this.fetchAllPlacements()
  },

  destroyed() {
    this.clearPlacements()
  },

  methods: {
    changeDateRange(value) {
      const { value: typeRange } = value

      this.updateValue({ key: 'dateRange', value })

      if (typeRange !== 'OTHER_RANGE') {
        this.updateValue({ key: 'customDateRange', value: [] })
        this.updateValue({ key: 'currentPage', value: 1 })
        this.fetchPlacementsByType(this.tableType)
      }
    },

    changeCustomRange(value) {
      if (value && value.length) this.fetchPlacementsByType(this.tableType)
    },

    changeCurrentPage(value) {
      this.updateValue({ key: 'currentPage', value })
      if (this.canFetchPlacements) this.fetchPlacementsByType(this.tableType)
    },

    changeSort({ prop, order }) {
      const { prop: oldProp, order: oldOrder } = this.params.sort

      if (prop !== oldProp || order !== oldOrder) {
        this.updateValue({ key: 'sort', value: { prop, order } })
        if (this.canFetchPlacements) this.fetchPlacementsByType(this.tableType)
      }
    },

    updateValue({ key, value }) {
      const params = {
        [key]: value
      }

      this.updateParams(this.tableType, params)
    },

    fetchAllPlacements() {
      if (!this.loading) this.$store.dispatch(types.FETCH_ALL_PLACEMENTS)
    },

    fetchPlacementsByType(name) {
      if (!this.loading) this.$store.dispatch(types.FETCH_PLACEMENTS_BY_TYPE, { name })
    },

    clearPlacements() {
      this.setList(this.tableType, [])
      this.updateParams(this.tableType, {
        sort: {
          prop: null,
          order: null
        },
        currentPage: 1,
        totalPage: null,
        isValidConversions: true,
        dateRange: null,
        customDateRange: [],
        count: 0
      })
    }
  }
}
</script>
